<div class="html-mail-creator-popover">
  <!-- ローディング表示 -->
  <div *ngIf="isLoading" class="loading-overlay">
    <mat-spinner></mat-spinner>
    <p>処理中...</p>
  </div>

  <!-- ポップオーバーヘッダー -->
  <div class="popover-header">
    <h2>{{ getDialogTitle() }}</h2>
  </div>

  <!-- ポップオーバー内容 -->
  <div class="popover-content">

    <!-- エラーメッセージ表示 -->
    <div *ngIf="errorMessages.length > 0" class="error-messages">
      <div *ngFor="let error of errorMessages" class="error-message">
        {{ error }}
      </div>
    </div>

    <!-- フォーム -->
    <form #htmlMailForm="ngForm" class="mail-form">

      <!-- テンプレート名 -->
      <div class="form-field">
        <label class="field-label">テンプレート名 <span class="required">*</span></label>
        <input
          type="text"
          name="name"
          maxlength="200"
          placeholder="テンプレート名を入力"
          [(ngModel)]="formData.name"
          [disabled]="isLoading"
          required
          autofocus
          class="form-input">
        <small class="field-hint">管理用の名称（メール件名とは別）</small>
      </div>

      <!-- 件名 -->
      <div class="form-field">
        <label class="field-label">件名 <span class="required">*</span></label>
        <input
          type="text"
          name="subject"
          maxlength="200"
          placeholder="メール件名を入力"
          [(ngModel)]="formData.subject"
          [disabled]="isLoading"
          required
          class="form-input">
      </div>

      <!-- 本文 -->
      <div class="form-field">
        <label class="field-label">本文（HTML） <span class="required">*</span></label>
        <textarea
          name="content"
          rows="10"
          placeholder="HTML本文を入力。画像は右の画像パネルから「挿入」ボタンで追加できます。"
          [(ngModel)]="formData.content"
          [disabled]="isLoading"
          required
          class="form-textarea">
        </textarea>
        <small class="field-hint">画像プレースホルダー形式: [img id="画像ID"]</small>
      </div>

    </form>

    <!-- 画像パネル -->
    <div class="image-panel">
      <div class="image-panel-header">
        <span class="image-panel-title">メッセージ画像管理</span>
        <span class="image-panel-note">未入力のままアップロードすると、メール専用の画像として登録します。両方を入力するとLINEにも添付できる画像になります。</span>
        <label>リンクURL（任意） <input type="url" [(ngModel)]="imageLinkUrl" maxlength="1000" [disabled]="isLoading"></label>
        <label>ALT（任意・LINE通知） <input type="text" [(ngModel)]="imageAltText" maxlength="400" [disabled]="isLoading"></label>
        <label class="upload-btn" [class.disabled]="isLoading">
          <input
            type="file"
            accept="image/*"
            (change)="onImageUpload($event)"
            [disabled]="isLoading"
            class="file-input">
          アップロード
        </label>
      </div>

      <div class="image-list" *ngIf="imageList.length > 0">
        <div *ngFor="let image of imageList" class="image-item">
          <span class="image-name" [title]="image.name">{{ image.name }}</span>
          <span class="image-id">ID:{{ image.id }}</span>
          <button
            mat-button
            type="button"
            (click)="onInsertImagePlaceholder(image)"
            [disabled]="isLoading"
            class="insert-btn">
            挿入
          </button>
          <button
            mat-icon-button
            type="button"
            (click)="onImageDelete(image)"
            [disabled]="isLoading"
            class="delete-btn"
            title="削除">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="imageList.length === 0" class="no-images">
        画像がありません
      </div>
    </div>

  </div>

  <!-- ポップオーバーアクション -->
  <div class="popover-actions">
    <button
      mat-flat-button
      type="button"
      (click)="onCancel()"
      [disabled]="isLoading">
      キャンセル
    </button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="onSave()"
      [disabled]="isLoading">
      {{ getSaveButtonLabel() }}
    </button>
  </div>
</div>
